import { IGetPayoutCommission } from 'src/store/api/payoutCommission/types';
import { createAction } from '@reduxjs/toolkit';

const setParams = createAction<IGetPayoutCommission['params']>('payoutCommissionsFilters/setParams');
const setBody = createAction<IGetPayoutCommission['data']>('payoutCommissionsFilters/setBody');
const clearCurr = createAction('payoutCommissionsFilters/clearFilters');
const clearBody = createAction('payoutCommissionsFilters/clearBody');

export const payoutCommissionsFiltersActions = {
  clearCurr,
  setParams,
  setBody,
  clearBody,
};
